import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Link} from 'react-router-dom';
import logo from './logo.svg';
import './App.css';
import Landing from './components/landing/landing';
import Portfolio from './components/portfolio/portfolio';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Router>
          <div>
            <Route exact path='/' component={Landing} />
            <Route path="/portfolio" component={Portfolio} />
          </div>
        </Router>

      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js